import { RecipeData } from 'types/Recipes';
import clsx from 'clsx';
import { useUserAgent } from 'hooks/useUserAgent';

interface Props {
  recipeData?: RecipeData;
}

const RecipeFooterPrint = ({ recipeData }: Props) => {
  const imprintText = recipeData?.longText?.longText?.text ?? '';
  const { isSafari } = useUserAgent();
  return (
    <div
      className={clsx(
        'recipe-print-footer bottom-0 h-[80px] break-after-avoid whitespace-pre-line text-center text-darkgray w-full text-xs uppercase',
        isSafari ? 'sticky' : 'fixed',
      )}
    >
      <div className="w-1/4 border-t border-t-grayBorder mx-auto pb-3"></div>
      {imprintText.replace(/\\n/g, '\n').trim()}
    </div>
  );
};

export default RecipeFooterPrint;
